/* global in_array, executeCustomCallback, Inputmask, device, define, module, commaToDot, ucFirst, generatorForms*/
(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        define('generatorForms', factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        global = global || self, global.generatorForms = factory();
    }
}(this, function () {
    /**
     * Set cursor to the end of input
     *
     * @param {jQuery} $elements
     * @param {Number} pos
     * @return {jQuery}
     */
    function _setCursorPosition($elements, pos) {
        $elements.each(function (index, elem) {
            // Hack for Chrome bug https://bugs.chromium.org/p/chromium/issues/detail?id=32865 that is still persist
            setTimeout(function () {
                if (elem.createTextRange) {
                    const range = elem.createTextRange();

                    range.collapse(true);
                    range.moveEnd('character', pos);
                    range.moveStart('character', pos);
                    range.select();
                } else if (elem.setSelectionRange) {
                    try {
                        elem.setSelectionRange(pos, pos);
                    } catch (err) {
                        if (err instanceof DOMException && err.name === 'InvalidStateError') {
                            // setSelectionRange does not apply to this input type for example: checkbox, radiobox and etc.
                        } else {
                            throw err;
                        }
                    }
                }
            }, 1);
        });

        return $elements;
    }

    /**
     *
     * @param {jQuery} $element
     * @return {Boolean}
     */
    function _isInViewport($element) {
        const elementTop = $element.offset().top;
        const elementBottom = elementTop + $element.outerHeight();

        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    /**
     *
     * @param {jQuery} $element
     * @return {Boolean}
     */
    function jqueryElementStillInDOM($element) {
        const htmlElement = $element[0];

        if (typeof htmlElement.isConnected !== 'undefined') {
            return htmlElement.isConnected;
        } else if (typeof document.contains !== 'undefined') {
            return document.contains(htmlElement);
        } else {
            return !!$element.closest('body').length;
        }
    }

    /**
     *
     * @return {Boolean}
     */
    function sweetAlertIsShown() {
        return ($('.swal2-container').length || $('body').hasClass('swal2-shown'));
    }

    /**
     *
     * @param {object|jQuery} $input
     * @return {undefined}
     */
    function _initInputMask($input) {
        let inputMaskType = $input.data('inputmask-type');
        const mask = $input.data('inputmask-mask');

        if (inputMaskType === 'date') {
            $input.inputmask('dd.mm.yyyy', {
                placeholder: 'дд.мм.гггг'
            });
        } else if (inputMaskType === 'datetime') {
            $input.inputmask('datetime', {
                placeholder: 'дд.мм.гггг, чч:мм',
                mask: '1.2.y, h:s',
                leapday: '02.29.',
                separator: '.'
            });
        } else if (inputMaskType === 'digits') {
            $input.inputmask('Regex', {
                regex: '[0-9]*'
            });
        } else if (in_array(inputMaskType, ['integer', 'decimal', 'numeric', 'money'])) {
            const allowMinus = !!$input.data('inputmask-allow-minus');
            const rightAlign = !!$input.data('inputmask-right-align');
            const placeholderPrefix = ($input.data('inputmask-placeholder') || '');
            const groupSeparator = (typeof $input.data('inputmask-separator') !== 'undefined' ? $input.data('inputmask-separator') : '');
            const isDecimalPlacesOptional = (typeof $input.data('inputmask-digits-optional') !== 'undefined' ? !!$input.data('inputmask-digits-optional') : true);

            let defaultNumberDecimalPlaces = false;

            if (inputMaskType === 'money') {
                // override mask type
                inputMaskType = 'numeric';
                defaultNumberDecimalPlaces = 2;
            } else if (inputMaskType === 'decimal' || inputMaskType === 'numeric') {
                defaultNumberDecimalPlaces = 2;
            }

            const numberDecimalPlaces = (typeof $input.data('inputmask-digits') !== 'undefined' ? $input.data('inputmask-digits') : defaultNumberDecimalPlaces);

            $input.inputmask(inputMaskType, {
                autoGroup: !!groupSeparator,
                groupSeparator: groupSeparator,
                digits: numberDecimalPlaces,
                digitsOptional: isDecimalPlacesOptional,
                placeholder: placeholderPrefix,
                allowMinus: allowMinus,
                // remove standart numeric rightAlign behavior if not specified
                rightAlign: rightAlign,
                radixPoint: '.',
                onKeyDown: function (e, buffer, caretPos, opts) {
                    if (opts.radixPoint === '.' && (e.keyCode === Inputmask.keyCode.COMMA || e.keyCode === Inputmask.keyCode.NUMPAD_DECIMAL || e.keyCode === 108)) {
                        // хак библиотеки потому что она не заменяет запятую на точку
                        e.preventDefault();

                        setTimeout(function () {
                            // отправляем keydown событие
                            const newKeyDownEvent = new jQuery.Event('keydown');

                            newKeyDownEvent.keyCode = Inputmask.keyCode.PERIOD;
                            newKeyDownEvent.which = Inputmask.keyCode.PERIOD;
                            newKeyDownEvent.key = '.';

                            $(e.target).trigger(newKeyDownEvent);

                            setTimeout(function () {
                                // отправляем keypress событие после keydown
                                const newKeyPressEvent = new jQuery.Event('keypress');

                                newKeyPressEvent.keyCode = Inputmask.keyCode.PERIOD - 144;
                                newKeyPressEvent.which = Inputmask.keyCode.PERIOD - 144;
                                newKeyPressEvent.key = '.';

                                $(e.target).trigger(newKeyPressEvent);
                            }, 5);
                        }, 5);
                    } else {
                        // вызываем оригинальное событие
                        Inputmask.prototype.aliases.numeric.onKeyDown(e, buffer, caretPos, opts);
                    }
                }
            });
        } else if (in_array(inputMaskType, ['url', 'ip', 'email'])
                || inputMaskType === 'custom'
                || (typeof inputMaskType === 'undefined' && typeof mask !== 'undefined')) {
            $input.inputmask(inputMaskType);
        } else if (inputMaskType === 'phone') {
            const maskList = $.masksSort($.masksLoad('/js/vendor/jquery_modules/inputmask-multi/phone-codes.json'), ['#'], /[0-9]|#/, 'mask');
            const maskOpts = {
                inputmask: {
                    definitions: {
                        '#': {
                            validator: '[0-9]',
                            cardinality: 1
                        }
                    },
                    showMaskOnHover: false
                },
                match: /[0-9]/,
                replace: '#',
                list: maskList,
                listKey: 'mask',
                onMaskChange: function (maskObj, completed) {
                    if (completed && typeof maskObj.cc === 'string') {
                        $('.flag_country').html('<img src="/img/flags/' + maskObj.cc.toLowerCase() + '.gif">');
                    } else {
                        $('.flag_country').html('');
                    }
                    $(this).attr('placeholder', $(this).inputmask('getemptymask'));
                }
            };
            $input.inputmasks(maskOpts);
        }
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {Boolean} error_occurred
     */
    function _disableSubmitButton($form_container, error_occurred) {
        console.debug('Disabling submit button');

        const $form_button = $form_container.find('.js-form_gen_button');
        error_occurred = (error_occurred !== undefined ? error_occurred : true);

        $form_button
            .attr('disabled', 'disabled')
            .prop('disabled', true)
            .addClass('disabled_ie');

        if (error_occurred) {
            $form_button.trigger('btn_error.generatorForms', true);
        }
    }

    /**
     *
     * @param {jQuery} $form_container
     * @return {boolean}
     */
    function _enableSubmitButton($form_container) {
        const $form = _getFormByFormContainer($form_container);

        if (_isFormSubmiting($form)) {
            console.debug('Skip enabling submit button. Still waiting for submit complete');

            return false;
        } else {
            console.debug('Enabling submit button');
        }

        $form_container.find('.js-form_gen_button')
            .removeAttr('disabled')
            .prop('disabled', false)
            .removeClass('disabled_ie')
            .trigger('btn_error.generatorForms', false);
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _disableSubmit($form_container) {
        const $form = _getFormByFormContainer($form_container);
        console.debug('Form now waiting for submit complete');

        $form.data('submit-in-progress', true);
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _enableSubmit($form_container) {
        const $form = _getFormByFormContainer($form_container);
        console.debug('Form submit complete');

        setTimeout(function () {
            // remove ajax form lock with delay to suppress unwanted checks right after complete submit (for events like change, blur)
            $form.data('submit-in-progress', false);
        }, 1000);
    }

    /**
     *
     * @param {jQuery} $form
     * @return {boolean}
     */
    function _isFormSubmiting($form) {
        return !!$form.data('submit-in-progress');
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {String} input_name
     * @return {*}
     */
    function _getInputByName($form_container, input_name) {
        return $form_container.find('.field_input [name="' + input_name + '"]');
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {String} input_name
     * @return {*}
     */
    function _getInputContainerByName($form_container, input_name) {
        return _getInputByName($form_container, input_name).parents('.field_input');
    }

    /**
     *
     * @async
     * @param {string} spoiler_name
     * @param {bool} is_opened
     * @return {(Promise|jqXHR)}
     */
    function _storeSpoilerState(spoiler_name, is_opened) {
        return $.ajax({
            type: 'POST',
            url: '/account/settings/spoiler',
            dataType: 'json',
            data: {
                spoiler_name: spoiler_name,
                state: is_opened
            },
            success: function (response) {
                if (!response.status) {
                    Swal.fire({title: 'Ошибка', html: response.message, icon: 'error'});
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error('Возникла ошибка: ' + jqXHR.responseCode + '; Текст ошибки: ' + textStatus);
            }
        });
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _removeAllErrorMarkers($form_container) {
        $form_container.find('.field_input.error').each(function () {
            if (!$(this).hasClass('forced_error')) {
                $(this).removeClass('error');
            }
        });
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _removeAllWarningMarkers($form_container) {
        $form_container.find('.field_input.warning').removeClass('warning');
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _removeAllValidMarkers($form_container) {
        $form_container.find('.field_input.valid').removeClass('valid');
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {String} input_name
     * @param {String} error_message
     */
    function _markInputInvalid($form_container, input_name, error_message) {
        const $input = _getInputByName($form_container, input_name);
        const $input_wrp = _getInputContainerByName($form_container, input_name);
        const $error_wrp = $input_wrp.find('.error_message');

        $input_wrp.removeClass('valid');

        const show_error_if_empty = !!$input_wrp.data('show-error-if-empty');

        if (!show_error_if_empty && $input.val() === '') {
            return;
        }

        // поле не селект либо select, но с значением не "wrong"
        $input_wrp.addClass('error');
        $error_wrp.html(error_message);
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {String} input_name
     * @param {String} warning_message
     */
    function _markInputWarning($form_container, input_name, warning_message) {
        const $input = _getInputByName($form_container, input_name);
        const $input_wrp = _getInputContainerByName($form_container, input_name);
        const $warning_wrp = $input_wrp.find('.error_message');

        if (!$input_wrp.hasClass('error') && $input.val() && $input.val() !== '') {
            $input_wrp.addClass('warning');
            $warning_wrp.html(warning_message);
        }
    }

    /**
     *
     * @param {jQuery} $form_container
     * @param {String} input_name
     */
    function _markInputVerified($form_container, input_name) {
        const $input_wrp = _getInputContainerByName($form_container, input_name);

        $input_wrp.removeClass('error').addClass('valid');
    }

    /**
     *
     * @param {jQuery} $form_container
     * @return {*}
     */
    function _findInvalidFieldsInFieldset($form_container) {
        const $set_wrap = $form_container.find('.form_row_group .group_row_container');
        const $errors = $set_wrap.find('.field_input.error');

        return $errors;
    }

    /**
     * Проверяем на наличие ошибок в свернутом блоке
     *
     * @param {jQuery} $form_container
     */
    function _expandFieldsetWithInvalidFields($form_container) {
        const $errors = _findInvalidFieldsInFieldset($form_container);

        if ($errors.length) {
            $errors.closest('.form_row_group').trigger('open');
        }
    }

    /**
     *
     * @param {jQuery} $form_container
     */
    function _markInputsAsValid($form_container) {
        _removeAllValidMarkers($form_container);

        $form_container.find('.field_input input[type!="hidden"], .field_input textarea, .field_input select').each(function () {
            const $input = $(this);
            const $input_wrp = $input.parents('.field_input');

            if ($input.val() !== null && $input.val() !== '' && !$input.prop('disabled') && !$input.is('[type="radio"]') && !$input_wrp.hasClass('error')) {
                if (!$input.is('select') || $input.val() !== 'wrong') {
                    // поле не селект либо select, но с значением не "wrong"
                    $input_wrp.addClass('valid');
                }
            }
        });
    }

    /**
     *
     * @param {Object} error_object
     * @param {jQuery} $form_container
     */
    function _handleErrorAnswer(error_object, $form_container) {
        console.debug('Started form error handle');

        _disableSubmitButton($form_container);

        _removeAllWarningMarkers($form_container);
        _removeAllErrorMarkers($form_container);

        for (const field_name in error_object) {
            _markInputInvalid($form_container, field_name, error_object[field_name]);
        }

        // раскрываем скрытый блок если в нем есть поле с ошибкой
        _expandFieldsetWithInvalidFields($form_container);
    }

    /**
     *
     * @param {jQuery} $form_container
     * @return {undefined}
     */
    function _init_events($form_container) {
        // отдельный счетчик для каждого контейнера
        let form_submit_timer;

        /**
         *
         * @param {Event} e
         * @param {jQuery} $form_container
         */
        function _debouncedAjaxFormSubmit(e, $form_container) {
            clearTimeout(form_submit_timer);

            form_submit_timer = setTimeout(function () {
                if (!jqueryElementStillInDOM($form_container) || sweetAlertIsShown()) {
                    /*
                     * 1) Если по истечению таймаута форма уже не существует - то и запросы выполнять не надо более (например потеря фокуса).
                     * 2) Аналогично если пользователю отображается окно swal то незачем делать проверку формы,
                     * тем более с сервера возможно снова вернется JS код, который например и отобразил это swal окошко
                     */
                    return;
                }

                _ajaxFormSubmit(e, $form_container);
            }, 800);
        }

        /**
         *
         * @param {Event} e
         * @param {jQuery} $form_container
         * @param {Boolean} is_saving
         * @return {boolean}
         */
        function _ajaxFormSubmit(e, $form_container, is_saving) {
            const $form = _getFormByFormContainer($form_container);
            const callback_submit_before = $form.data('callback-submit-before');
            const callback_submit_after = $form.data('callback-submit-after');
            const callback_check_before = $form.data('callback-check-before');
            const callback_check_after = $form.data('callback-check-after');
            const callback_error_before = $form.data('callback-error-before');
            const callback_error_after = $form.data('callback-error-after');
            let callback_result;

            // Обработчики до и после выполнения AJAX запроса. Могут быть разными в зависимости от того сохраняется форма или нет
            let callback_ajax_before;
            let callback_ajax_after;
            // Обработчик неверного ответа для AJAX
            let ajax_error_reporting;

            // заменяет в нужных полях запятые на точки
            $form_container.find('.field_input input[data-todot="1"]').each(function () {
                const fixed_val = commaToDot($(this).val());

                if ($(this).val() !== fixed_val) {
                    $(this).val(commaToDot($(this).val()));
                    $(this).trigger('input');
                    $(this).trigger('change');
                }
            });

            // заменяет в нужных полях первую букву на заглавную
            if (!$form.data('disable-upcase')) {
                $form_container.find('.field_input input[data-ucfirst="1"]').each(function () {
                    const fixed_val = ucFirst($(this).val());

                    if ($(this).val() !== fixed_val) {
                        $(this).val(ucFirst($(this).val()));
                    }
                });
            }

            // если проверка на ошибки отключена то прерываем
            if (!is_saving && $form.data('no-check-errors') == '1') {
                return true;
            }

            if (_isFormSubmiting($form)) {
                console.debug('Skip form inputs check or submit. Still waiting for submit complete');

                return false;
            }

            if (is_saving) {
                // влючаем блокировку включения кнопки отправки и отправки новых ajax запросов пока этот запрос не выполнится
                _disableSubmit($form_container);

                // Предотвращаем отложенную проверку формы сразу после отправки формы на сохранение
                clearTimeout(form_submit_timer);

                callback_ajax_before = callback_submit_before;
                callback_ajax_after = callback_submit_after;
                ajax_error_reporting = (error_message) => Swal.fire({title: error_message, icon: 'warning'});

                $form.trigger('onBeforeSave.generatorForms');
            } else {
                callback_ajax_before = callback_check_before;
                callback_ajax_after = callback_check_after;
                ajax_error_reporting = console.error;

                $form.trigger('onBeforeValidate.generatorForms');
            }

            if (callback_ajax_before) {
                // вызов кастомного коллбека
                callback_result = executeCustomCallback(callback_ajax_before, $form_container, e);

                if (callback_result === false) {
                    if (is_saving) {
                        // убираем индикатор загрузки
                        $form_container.find('.ajax_loader').remove();
                    }

                    return false;
                }
            }

            const sending_data = $form.serialize() + (is_saving ? '&act=submit' : '&act=check');

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                dataType: 'json',
                cache: false,
                data: sending_data,
                complete: function () {
                    if (is_saving) {
                        $form.trigger('onSavingComplete.generatorForms');

                        // убираем индикатор загрузки
                        $form_container.find('.ajax_loader')
                            .remove();
                    } else {
                        $form.trigger('onValidateComplete.generatorForms');
                    }
                },
                success: function (result) {
                    if (is_saving) {
                        // отключаем блокировку
                        _enableSubmit($form_container);
                    }

                    if (result && Object.prototype.toString.call(result) === '[object Object]') {
                        if (callback_error_before) {
                            // вызов кастомного коллбека
                            callback_result = executeCustomCallback(callback_error_before, result, $form_container);

                            if (callback_result === false) {
                                return false;
                            }
                        }

                        if (result.errors) {
                            // Обработка ошибок в новом формате: {errors: {}, warnings: {}}
                            if (Object.prototype.toString.call(result.errors) === '[object Object]') {
                                // Обработка ошибок в новой реализации
                                _handleErrorAnswer(result.errors, $form_container);

                                $form.trigger('onValidateError.generatorForms', result);
                            } else if (Object.prototype.toString.call(result.errors) === '[object Array]') {
                                // пустой массив - форма без ошибок
                                _removeAllErrorMarkers($form_container);
                                _removeAllWarningMarkers($form_container);
                                _markInputsAsValid($form_container);
                                _enableSubmitButton($form_container);

                                $form.trigger('onValidateSuccess.generatorForms', {errors: result.errors, warnings: result.warnings});
                            }

                            if (result.warnings && Object.prototype.toString.call(result.warnings) === '[object Object]') {
                                // Добавляем предупреждение для полей, не блокирующих отправку формы
                                for (const field_name in result.warnings) {
                                    _markInputWarning($form_container, field_name, result.warnings[field_name]);
                                }
                            }
                        } else {
                            // Совместимость с предыдущей реализацией, когда возвращался одноуровневый объект
                            _handleErrorAnswer(result, $form_container);

                            $form.trigger('onValidateError.generatorForms', {errors: result, warnings: {}});
                        }

                        _markInputsAsValid($form_container);

                        if (callback_error_after) {
                            // вызов кастомного коллбека
                            callback_result = executeCustomCallback(callback_error_after, result, $form_container);

                            if (callback_result === false) {
                                return false;
                            }
                        }
                    } else if (Object.prototype.toString.call(result) == '[object Array]') {
                        if (result.length) {
                            // не пустой массив, пробуем выполнить первый элемент
                            _markInputsAsValid($form_container);
                            eval(result[0]);
                        } else {
                            // пустой массив - форма без ошибок
                            _removeAllErrorMarkers($form_container);
                            _removeAllWarningMarkers($form_container);
                            _markInputsAsValid($form_container);
                            _enableSubmitButton($form_container);
                        }

                        if (is_saving) {
                            $form.trigger('onSaveSuccess.generatorForms', {errors: {}, warnings: {}});
                        }

                        $form.trigger('onValidateSuccess.generatorForms', {errors: {}, warnings: {}});
                    } else if (is_saving) {
                        // Обратная совместимость
                        const success_msg = $form_container.find('.success_msg').text();

                        // если пришел не массив то делаем обычные условия
                        switch (result) {
                            case 'edited': // ответ при редактировании
                                _enableSubmitButton($form_container);
                                Swal.fire({title: success_msg, icon: 'success'});

                                $form.trigger('onSaveSuccess.generatorForms', result);

                                break;
                            case 'error':
                                Swal.fire({title: 'Ошибка. Повторите попытку позже.', icon: 'success'});

                                $form.trigger('onSaveError.generatorForms', result);

                                break;
                            default:
                                _disableSubmitButton($form_container);
                                Swal.fire({title: 'Произошла ошибка:', icon: 'error'});

                                $form.trigger('onSaveError.generatorForms', result);

                                break;
                        }
                    }

                    if (callback_ajax_after) {
                        // вызов кастомного коллбека
                        callback_result = executeCustomCallback(callback_ajax_after, result, $form_container);

                        if (callback_result === false) {
                            return false;
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // Вернулся неверный ответ. Блокируем кнопку отправки формы
                    _disableSubmitButton($form_container);

                    if (is_saving) {
                        // отключаем блокировку
                        _enableSubmit($form_container);
                    }

                    $form_container.find('.ajax_loader')
                        .remove();
                    ajax_error_reporting('Возникла ошибка: ' + jqXHR.responseCode + '; Текст ошибки: ' + textStatus);
                }
            });
        }

        $form_container.on('validate.generatorForms', 'form', function () {
            _debouncedAjaxFormSubmit('validate', $form_container);
        });

        // отправка формы
        $form_container.on('submit.generatorForms', 'form', function (e) {
            console.debug('Submiting form');

            e.preventDefault();

            // делаем кнопку не активной для особо нервных
            _disableSubmitButton($form_container, false);

            const $button = $form_container.find('.js-form_gen_button');
            $button.after('<img class="ajax_loader" src="/img/ajax_loader.gif" alt="Loading" title="Подождите идет отправка формы" width="20" />');

            _ajaxFormSubmit(e, $form_container, true);
        });

        const inputSelector = '.field_input :input:visible:not(:hidden,:disabled,button,[type="file"])';
        const inputEvents = 'focus.generatorForms blur.generatorForms keydown.generatorForms keyup.generatorForms change.generatorForms input.generatorForms';

        $form_container.on(inputEvents, inputSelector, function (e) {
            const $input_wrap = $(this).closest('.field_input');

            let autofocus = $input_wrap.data('autofocus');

            if (autofocus === undefined) {
                autofocus = true;
            }

            const event_name = (e.handleObj ? e.handleObj.origType : e.type);

            console.debug('Input event: ' + event_name);

            switch (e.type) {
                case 'focusin':
                case 'focus':
                    // убираем класс focused у других input'ов с любых форм, если остался
                    $('.field_input.focused').removeClass('focused');

                    // добавляем текущему контейнеру класс focused
                    $input_wrap.addClass('focused');

                    _debouncedAjaxFormSubmit(e, $form_container);

                    if ($(this).val()) {
                        // ставим фокус в конец инпута
                        _setCursorPosition($(this), $(this).val().length);
                    }
                    break;
                case 'focusout':
                case 'blur':
                    _debouncedAjaxFormSubmit(e, $form_container);
                    break;
                case 'keydown':
                    // Изменяем стандартное поведение Enter и Tab
                    if (!$input_wrap.hasClass('focused')) {
                        // убираем класс focused у других input'ов с любых форм, если остался
                        $('.field_input.focused').removeClass('focused');

                        $input_wrap.addClass('focused');
                    }

                    if ((e.keyCode == 13 && !e.shiftKey) || e.keyCode == 9) {
                        e.preventDefault();
                    }
                    break;
                case 'keyup':
                    // При нажатии на Enter или Tab переходим на следующее/предыдущее поле
                    if ((e.keyCode == 13 && !e.shiftKey) || e.keyCode == 9) {
                        const $input_collect = $form_container.find(inputSelector);
                        const input_count = $input_collect.length;
                        let index = $input_collect.index($(this));

                        if (e.keyCode == 9 && e.shiftKey) {
                            --index;
                        } else {
                            ++index;
                        }

                        // если индекс текущего элемента больше или равен кол-ву элементов, то переходим на первый элемент
                        if (index >= input_count || index < 0) {
                            index = 0;
                        }

                        if (autofocus) {
                            $input_collect.eq(index).focus();
                        }
                    }

                    /*
                     * Note: oninput event is also buggy in IE9 and it is not fired on deletion.
                     *
                     * Вот поэтому добавляем проверку в этом событии
                     */
                    _debouncedAjaxFormSubmit(e, $form_container);
                    break;
                case 'input':
                    // блокируем кнопку отправки сразу после изменения в форме, не дожидаясь ajax запроса
                    _disableSubmitButton($form_container, false);
                // eslint-disable-next-line no-fallthrough
                case 'change':
                    _debouncedAjaxFormSubmit(e, $form_container);
                    break;
            }
        });

        $form_container.on('open', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // open(show) only content of container
            const $parent_container = $(this);
            const $set_wrap = $(this).children('.group_row_container');

            console.debug('Form group container event: open', $set_wrap);

            const after_open_callback = function () {
                $parent_container.addClass('open');

                if (typeof callback === 'function') {
                    callback();
                }

                if ($parent_container.data('remember') === 1) {
                    if ($parent_container.attr('id')) {
                        _storeSpoilerState($parent_container.attr('id'), true);
                    } else {
                        console.error('No spoiler id attribute is present to remember state.');
                    }
                }
            };

            if ($parent_container.data('noanimate')) {
                after_open_callback();
            } else {
                $set_wrap.slideDown('fast', after_open_callback);
            }
        });

        $form_container.on('close', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // close(hide) only content of container
            const $parent_container = $(this);
            const $set_wrap = $(this).children('.group_row_container');
            const $errors = $parent_container.find('.field_input.error');

            console.debug('Form group container event: close', $set_wrap);

            const after_close_callback = function () {
                $parent_container.removeClass('open');

                if (typeof callback === 'function') {
                    callback();
                }

                if ($parent_container.data('remember') === 1) {
                    if ($parent_container.attr('id')) {
                        _storeSpoilerState($parent_container.attr('id'), false);
                    } else {
                        console.error('No spoiler id attribute is present to remember state.');
                    }
                }
            };

            if (!$errors.length) {
                if ($parent_container.data('noanimate')) {
                    after_close_callback();
                } else {
                    $set_wrap.slideUp('fast', after_close_callback);
                }
            }
        });

        $form_container.on('show', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // show container
            const $container = $(this);
            console.debug('Form group container event: show', $container);

            $container.removeClass('hidden');

            if (typeof callback === 'function') {
                callback();
            }
        });

        $form_container.on('hide', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // hide container
            const $container = $(this);
            console.debug('Form group container event: hide', $container);

            $container.addClass('hidden');

            if (typeof callback === 'function') {
                callback();
            }
        });

        $form_container.on('show-open', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // show container and open fields
            const $container = $(this);
            console.debug('Form group container event: show-open', $container);

            $container.trigger('show', function () {
                // open fields when container are visible
                $container.trigger('open', callback);
            });
        });

        $form_container.on('close-hide', '.form_row_group', function (event, callback) {
            if (event.target !== event.currentTarget) {
                // event was bubbled from nested(child) element with same class
                return;
            }

            // close fields and hide container
            const $container = $(this);
            console.debug('Form group container event: close-hide', $container);

            $container.trigger('close', function () {
                // hide container completely when fields are closed
                $container.trigger('hide', callback);
            });
        });

        $form_container.on('click', '.form_row_group .group_row_header', function () {
            const $parent_container = $(this).parent();

            if ($parent_container.hasClass('open')) {
                $parent_container.trigger('close');
            } else {
                $parent_container.trigger('open');
            }
        });

        $form_container.on('show-form-row', '.form_row', function (event, callback) {
            // show container
            const $container = $(this);
            console.debug('Form row container event: show', $container);

            $container.removeClass('hidden');

            if (typeof callback === 'function') {
                callback();
            }
        });

        $form_container.on('hide-form-row', '.form_row', function (event, callback) {
            // hide container
            const $container = $(this);
            console.debug('Form row container event: hide', $container);

            $container.addClass('hidden');

            if (typeof callback === 'function') {
                callback();
            }
        });
    }

    /**
     *
     * @param {jQuery} $form_container
     * @return {jQuery}
     */
    function _getFormByFormContainer($form_container) {
        if ($form_container.is('form')) {
            return $form_container;
        } else {
            return $form_container.find('form');
        }
    }

    /**
     *
     * @param {jQuery} $form
     * @return {jQuery}
     */
    function _getFormContainerByForm($form) {
        if ($form.hasClass('form_gen_wrapper')) {
            return $form;
        } else {
            return $form.closest('.form_gen_wrapper');
        }
    }

    /**
     * основной скрипт
     *
     * @param {jQuery} $obj
     * @return {Boolean}
     */
    function _init($obj) {
        if ($obj.length > 1) {
            // передано более одной формы - инициализируем каждую отдельно
            $obj.each(function () {
                _init($(this));
            });

            return;
        }

        const $form_container = _getFormContainerByForm($obj);
        const $form = _getFormByFormContainer($obj);

        if ($form_container.data('noforminit') == '1') {
            // прерываем инициализацию обработчика формы
            return false;
        }

        // чтобы не инициализировать форму повторно
        if ($form_container.data('initialized')) {
            // прерываем инициализацию обработчика формы
            return false;
        } else {
            $form_container.data('initialized', 1);
        }

        _init_events($form_container, $form_container);

        // Инициализируем поля для ввода по маске
        $form_container.find('.field_input input[data-inputmask-type], .field_input input[data-inputmask-mask]').each(function () {
            _initInputMask($(this));
        });

        if (!device || device.type === 'desktop') {
            // Ищем поле которое должно иметь фокус(после того как событие onFocus уже висит на полях ввода)
            let $focus_input = $form_container.find('.field_input [autofocus]');

            if ($focus_input.length) {
                // форсируем событие фокуса для js
                $focus_input.first().focus();
            } else if ($form_container.is(':visible') && _isInViewport($form_container)) {
                // Иначе ставим фокус на первое доступное поле для ввода
                $focus_input = $form_container.find('.field_input :input:visible:enabled').first();
                $focus_input.focus();
            }
        }

        // Запускаем коллбэк после инициализации формы
        const callback_init_after = $form.data('callback-init-after');

        if (callback_init_after) {
            executeCustomCallback(callback_init_after, $form_container);
        }

        $form.trigger('form_init.generatorForms');
    }

    const generatorForms = {
        // public methods
        init: _init,
        initInputMask: _initInputMask,
        enableSubmitButton: _enableSubmitButton,
        disableSubmitButton: _disableSubmitButton,
        enableSubmit: _enableSubmit,
        disableSubmit: _disableSubmit
    };

    // export
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    return generatorForms;
}));

/* eslint-disable no-redeclare */
/**
 * основной скрипт
 *
 * @param {jQuery} $obj
 * @return {Boolean}
 */
function genFormInit($obj) {
    /* eslint-enable no-redeclare */
    return generatorForms.init($obj);
}

$(document).ready(function () {
    // вынести инициализацию
    setTimeout(function () {
        /*
         * setTimeout нужен чтобы событие инициалиации на форме точно сработало
         * для подписчиков и не зависело от порядка подключения JS скриптов
         */
        genFormInit($('.form_gen_wrapper'));
    }, 0);
});
